// 配置登录时长 12个小时
export const EXPIRE_TIME = 2 * 60 * 60 * 1000